var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('result-map',{attrs:{"blocks":_vm.blocks,"isDashboardMap":true,"orgCustomisations":{}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }